import { render, staticRenderFns } from "./AppointmentTravelNotificationMessagedCustomer.vue?vue&type=template&id=3a99de69"
import script from "./AppointmentTravelNotificationMessagedCustomer.vue?vue&type=script&lang=js"
export * from "./AppointmentTravelNotificationMessagedCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports